import React from 'react';
import ReactDOM from 'react-dom';
import VideoDetails from './PinVideoDetails';

class PinVideoDetailsHandler {
    constructor() {
        //listen to the video player end
        if( window.FsVideoEventHandler ) { 
            window.FsVideoEventHandler.onPlayerLoaded((data) => this.initVideoDetails(data));
        }
    }

    initVideoDetails(data) {
        data = data.playerData;
        let player = document.getElementById('Video' + data.id);
        let detailsCont = player.parentElement.parentElement.querySelector( '.fs-video-details' );

        if(detailsCont) {
            ReactDOM.render(<VideoDetails data={data}/>, detailsCont);
        }
    }
}

export default new PinVideoDetailsHandler();